// extracted by mini-css-extract-plugin
export var container = "_gd-0";
export var content = "_gd-3";
export var customerTitle = "_gd-4";
export var empty = "_gd-5";
export var gray = "_gd-6";
export var header = "_gd-7";
export var info = "_gd-8";
export var loading = "_gd-2";
export var loadingCard = "_gd-9";
export var oneLine = "_gd-a";
export var personName = "_gd-e";
export var pillContainer = "_gd-b";
export var selected = "_gd-1";
export var text = "_gd-c";
export var twoLines = "_gd-d";
export var unread = "_gd-f";
export var unreadIndicator = "_gd-g";